import React, { useMemo } from "react"

import {
    Dialog,
    DialogTitle,
    DialogContent,
    Avatar,
    Typography,
    Stack,
    Divider,
    Box,
    DialogActions,
    Button,
} from "@mui/material"
import extractLeadFormResponses from "./extractLeadFormResponses"

const ModalLeadResponses = ({ open, handleClose, lead }) => {
    if (!lead) return null

    const formRes = useMemo(() => {
        return extractLeadFormResponses(lead)
    }, [lead])

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Detalhes do Lead</DialogTitle>
            <DialogContent dividers>
                <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Avatar
                        src={lead.contact?.profilePicUrl}
                        alt={lead.contact?.name}
                        sx={{ width: 56, height: 56 }}
                    />
                    <Box>
                        <Typography variant="h6">{lead.name}</Typography>
                        <Typography variant="body2">{lead.number}</Typography>
                        <Typography variant="body2">{lead.email}</Typography>
                    </Box>
                </Stack>

                <Divider sx={{ my: 2 }} />

                {formRes.map((response, index) => (
                    <Box key={index} mb={2}>
                        <Box marginBottom={2}>
                            <Typography variant="subtitle2" color="primary">
                                {`Formulário: ${response.title}`}
                            </Typography>
                            <Typography variant="body1" fontWeight="bold">
                                {response.description}
                            </Typography>
                            <Typography variant="caption">
                                {`UTM Source: ${response.utm_source}`}
                            </Typography>
                        </Box>

                        {response.responses.map((response) => (
                            <Stack marginBottom={1} key={response.id}>
                                <Typography
                                    variant="caption"
                                    fontWeight="bold"
                                    fontStyle="italic"
                                >
                                    {`P: ${response.questionText}`}
                                </Typography>
                                <Typography variant="body1">
                                    {`R: ${response.formattedAnswer}`}
                                </Typography>
                            </Stack>
                        ))}
                        <Divider sx={{ my: 1 }} />
                    </Box>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalLeadResponses
